import { z } from "zod";

/** Search wording is prepared before confirmation and included in the action hash. */
export const SearchLocalizationSchema = z.object({
  originalQuery: z.string().trim().min(1).max(160),
  query: z.string().trim().min(1).max(160),
  language: z.string().regex(/^[a-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/).max(35),
  basis: z.enum(["user_requested", "source_content", "target_market", "language_neutral"]),
  reason: z.string().trim().min(1).max(300),
  evidenceQuote: z.string().max(500).optional(),
}).strict();
export type SearchLocalization = z.infer<typeof SearchLocalizationSchema>;

/** Literal provenance checks do not pretend to prove semantic translation quality. */
export function validSearchLocalization(value: SearchLocalization, input: { originalQuery: string; query: string; message: string; visibleText?: string }) {
  return value.originalQuery === input.originalQuery.trim() && value.query === input.query.trim()
    && input.message.includes(value.originalQuery)
    && (value.basis !== "source_content" || !!value.evidenceQuote && !!input.visibleText?.includes(value.evidenceQuote) && value.evidenceQuote.includes(value.originalQuery))
    && (value.basis !== "language_neutral" || value.query === value.originalQuery);
}

/** Only flag a clear script/market mismatch; never assume all overseas sites use English. */
export function needsSearchLanguageDecision(query: string, url?: string, country?: string | null) {
  if (!/[\p{Script=Han}]/u.test(query)) return false;
  if (country && ["US", "GB", "DE", "FR", "ES", "IT", "BR", "MX", "TH", "VN", "ID"].includes(country)) return true;
  if (!url) return false;
  try { return /(?:^|\.)amazon\.(?:com|co\.uk|de|fr|es|it|com\.br|com\.mx)$|(?:^|\.)shopee\.(?:co\.th|vn|co\.id|com\.br)$/.test(new URL(url).hostname); }
  catch { return false; }
}
